import { Tooltip } from 'antd';
import React from 'react';
import { Container, FilterIcon, FilterTag } from './styles';

export enum EFilterTagTypes {
  STATE = 'STATE',
  EMITTER = 'EMITTER',
  RECEIVER = 'RECEIVER',
  DATE = 'DATE',
  STATUS = 'STATUS',
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  SEARCH_INPUT = 'SEARCH_INPUT'
}

export interface IFilterTag {
  filterTagType: EFilterTagTypes;
  filterText: string;
  canBeRemoved?: boolean;
}

interface IFiltersTagsProps {
  tags: IFilterTag[];
  onRemoveTag(tag: IFilterTag, idx: number): void;
}

const FiltersTags: React.FC<IFiltersTagsProps> = ({ tags, onRemoveTag }) => {
  const getTitle = (tagType: EFilterTagTypes): string => {
    switch (tagType) {
      case EFilterTagTypes.STATE:
        return 'Estado ';
      case EFilterTagTypes.EMITTER:
        return 'Emissor: ';
      case EFilterTagTypes.RECEIVER:
        return 'Recebedor: ';
      case EFilterTagTypes.DATE:
        return 'Data: ';
      case EFilterTagTypes.STATUS:
        return 'Status: ';
      case EFilterTagTypes.PRODUCT_TYPE:
        return 'Tipo de produto: ';
      default:
        return '';
    }
  };

  return (
    <Container>
      <div className="title-container">
        <FilterIcon />
        <span>Filtros:</span>
      </div>

      <div className="tags-container">
        {tags.map((tag, idx) => (
          <FilterTag key={idx} className={`tag-${idx}`}>
            <span>
              {getTitle(tag.filterTagType) !== '' && (
                <span className="filter-type">
                  {getTitle(tag.filterTagType)}
                </span>
              )}
              {tag.filterText}
            </span>

            {tag.canBeRemoved && (
              <Tooltip
                title={'Remover filtro'}
                placement="bottomLeft"
                trigger={['hover']}
              >
                <button
                  onClick={() => {
                    document
                      .getElementsByClassName(`tag-${idx}`)[0]
                      .classList.add('remove-tag');
                    setTimeout(() => {
                      document
                        .getElementsByClassName(`tag-${idx}`)[0]
                        .classList.remove('remove-tag');
                      onRemoveTag(tag, idx);
                    }, 400);
                  }}
                >
                  x
                </button>
              </Tooltip>
            )}
          </FilterTag>
        ))}
      </div>
    </Container>
  );
};

export default FiltersTags;
